import type {
  StayGuestProfileField,
  StayPlaybookTemplateKey,
} from "./stayData"

export type GuestProfileCategory = {
  field: StayGuestProfileField
  label: string
  options: readonly string[]
}

export const guestProfileCategories = [
  {
    field: "meal_requirements",
    label: "Dietary Requirements",
    options: [
      "None",
      "Celiac disease",
      "Diabetic",
      "Gluten Intolerant",
      "Halaal",
      "Kosher",
      "Lacto-Vegetarian",
      "Lacto-ovo Vegetarian",
      "Low Cholesterol",
      "Low Protein",
      "Low Purine",
      "Low sodium/salt",
      "Non/Low Lactose",
      "Ovo-Vegetarian",
      "Pescatarian",
      "Vegan",
      "Vegetarian",
    ],
  },
  {
    field: "allergies",
    label: "Allergies",
    options: [
      "None",
      "Chilli",
      "Cilantro/coriander",
      "Dairy Products",
      "Egg",
      "MSG",
      "Milk",
      "Nut",
      "Penicillin",
      "Seafood",
      "Shell Fish",
      "Soy",
      "Tartrazine",
      "Tomatoes",
      "Wheat",
    ],
  },
  {
    field: "specific_needs",
    label: "Specific Needs",
    options: [
      "None",
      "Difficulty with walking",
      "Hearing Impaired",
      "Travelling with medical equipment",
      "Travelling with oxygen",
      "Travelling with mobility aids",
      "Visually impaired",
      "Wheelchair bound",
    ],
  },
] satisfies readonly GuestProfileCategory[]

export const playbookKeyByGuestProfileField = {
  meal_requirements: "dietaries",
  allergies: "allergies",
  specific_needs: "specific_needs",
} satisfies Record<StayGuestProfileField, StayPlaybookTemplateKey>

export const guestProfileModalCopy = {
  meal_requirements: {
    description:
      "Capture dietary requirements that materially affect meals and planning, and make sure they are clearly tied to the right guest.",
    editTitle: "EDIT DIETARY REQUIREMENTS",
    heading: "Add Dietary requirements",
    title: "ADD DIETARY REQUIREMENTS",
  },
  allergies: {
    description: "Record confirmed allergies the camp should consistently act on, not one-off preferences.",
    editTitle: "EDIT ALLERGIES",
    heading: "Add Allergies",
    title: "ADD ALLERGIES",
  },
  specific_needs: {
    description: "Record practical needs the camp should consistently act on, not one-off preferences.",
    editTitle: "EDIT SPECIAL NEEDS REQUIREMENTS",
    heading: "Add Special needs",
    title: "ADD SPECIAL NEEDS REQUIREMENTS",
  },
} satisfies Record<StayGuestProfileField, {
  description: string
  editTitle: string
  heading: string
  title: string
}>
